/* cc-collapsible-description — read-more toggle over the product
   description. 1:1 behavior port of Empire's inline script (2026-07-09):
   280px collapse, +20px tolerance (short descriptions render open with
   no link), label + icon swap. Custom element so re-rendered markup
   re-inits itself; no observers, no polling. */
(() => {
  if (customElements.get('cc-collapsible-description')) return;

  const DEFAULT_MAX = 280; // px — Empire's collapsed height (see CSS)

  class CCCollapsibleDescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ccInit) return;
      this.dataset.ccInit = '1';

      const wrap = this.querySelector('[data-desc]');
      const link = this.querySelector('[data-toggle]');
      const label = this.querySelector('[data-label]');
      const icon = this.querySelector('[data-icon]');
      if (!wrap || !link || !label || !icon) return;

      const max = parseInt(this.dataset.collapsed, 10) || DEFAULT_MAX; // per-instance (collection banner uses 120)
      if (wrap.scrollHeight <= max + 20) {
        link.style.display = 'none';
        wrap.classList.add('is-open');
        return;
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const open = wrap.classList.toggle('is-open');
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? 'Read less' : 'Read more';
        icon.textContent = open ? '−' : '+';
      });
    }
  }

  customElements.define('cc-collapsible-description', CCCollapsibleDescription);
})();
